import { typographyStyles, constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const tableCss = {
  root: [
    typographyStyles.textS,
    {
      width: "100%",
      color: constants.colors.ui.neutral[600],
      table: {
        width: "100%",
      },
      marginBottom: "25px",
      th: [
        typographyStyles.heading5,
        {
          fontWeight: "bold",
          padding: "12px",
          textAlign: "left",
        },
      ],
      td: {
        padding: "12px",
      },
    },
  ],
};

export const modalStyles = {
  modalContentWrapper: {
    width: "100% !important",
    maxWidth: "1200px !important",
    height: "650px !important",
    maxHeight: "650px !important",
  },
  root: {
    zIndex: 10,
  },
  footer: {
    minHeight: "inherit",
  },
};

export const modalFooterStyles = {
  display: "flex",
  justifyContent: "end",
};

export const modalFooterUploadButtonStyles = {
  root: {
    backgroundColor: ui.core[700],
  },
};

export const modalFooterCancelButtonStyles = {
  root: {
    marginRight: "16px",
    borderColor: ui.core[700],
    color: ui.core[700],
  },
};
